export default __webpack_public_path__ + "static/media/hht2_storybook_07.351c41f4.png";